export const ADMIN = {
    roomIds: [107],
};
